import { Injectable } from "@angular/core";
import { ApiService } from "./Api.service";

@Injectable({
  providedIn: "root",
})
export class WebPageService {
  constructor(private apiService: ApiService) {}

  /**
   * Public institutional web-page content.
   * GET {api_url}/public/web-page
   * Returns general info, cover, about, value propositions, levels,
   * milestones (timeline) and similar institutions.
   */
  async getWebPage() {
    try {
      const res = await this.apiService.get("public/web-page");
      return res;
    } catch (error) {
      return error;
    }
  }
}
